import { API_BASE_URL } from "@/config/env";
import { axiosInstance } from "@/axios/config";
/** Popup action key consumed by PopupWithBtn.vue */
export const LEGACY_WEB_SSO_ACTION = "legacy-web-sso";

const ORANGE_POPUP_STATUS = "orange";

/**
 * Resolve legacy alwsata web base URL (no trailing slash).
 * Prefer VUE_APP_LEGACY_WEB_URL; otherwise strip "/api" from the API host.
 */
export function getLegacyWebBaseUrl() {
  const configured = (process.env.VUE_APP_LEGACY_WEB_URL || "").trim();
  if (configured) {
    return configured.replace(/\/+$/, "");
  }

  const apiBase = (API_BASE_URL || "").replace(/\/+$/, "");
  if (apiBase.endsWith("/api")) {
    return apiBase.slice(0, -4);
  }

  return apiBase;
}

/**
 * Fetch a one-time signed SSO URL from wsata_api (admin / sales manager only).
 * @param {number|string} targetUserId
 * @returns {Promise<string>}
 */
export async function fetchLegacyWebSsoUrl(targetUserId) {
  const id = Number(targetUserId);
  if (!id) {
    throw new Error("معرّف المستخدم غير صالح");
  }

  console.log('fetchLegacyWebSsoUrl', id);
  const { data } = await axiosInstance.get(
    `/v2/employee/legacy-web/sso-url/${id}`
  );

  const url = data?.payload?.url;  if (!url) {
    throw new Error(data?.message || "تعذر إنشاء رابط الدخول للويب");
  }

  return url;
}

/**
 * Open the user's legacy web dashboard in a new tab (SSO).
 * @param {number|string} targetUserId
 * @param {{ newTab?: boolean }} [options]
 */
export async function openLegacyWebDashboard(targetUserId, options = {}) {
  const url = await fetchLegacyWebSsoUrl(targetUserId);
  const newTab = options.newTab !== false;

  if (newTab) {
    const opened = window.open(url, "_blank", "noopener,noreferrer");
    if (!opened) {
      window.location.href = url;
    }
    return url;
  }

  window.location.href = url;
  return url;
}

/**
 * Show orange popup with "استمرار في الويب" for General Manager (role 4).
 * Callable from any component via: this.$legacyWeb.promptGeneralManager(...).
 *
 * @param {import('vue').default|{ $root: import('vue').default }} vm
 * @param {{ userId: number|string, message?: string, buttonLabel?: string }} options
 */
export function promptGeneralManagerLegacyWeb(vm, options = {}) {
  const userId = options.userId;  const message =
    options.message ||
    "لوحة المدير العام غير متاحة في التطبيق الجديد. يمكنك المتابعة على الويب.";
  const buttonLabel = options.buttonLabel || "استمرار في الويب";

  const root = vm && vm.$root;
  if (!root || typeof root.$emit !== "function") {
    return false;
  }

  root.$emit("popup-btn", ORANGE_POPUP_STATUS, message, buttonLabel, {    action: LEGACY_WEB_SSO_ACTION,
    userId: userId != null && userId !== "" ? Number(userId) : null,
  });

  return true;
}

/**
 * After switchLoggedUser response — if role is blocked in Vue, offer legacy web.
 * @returns {boolean} true when legacy prompt was shown (caller should stop Vue switch flow)
 */
export function handleBlockedRoleForVueSwitch(vm, payload, options = {}) {
  if (!payload || Number(payload.role) !== 4) {    return false;
  }

  const userId =
    options.targetUserId ||
    payload.agent_id ||
    payload.id ||
    payload.user_id;

  promptGeneralManagerLegacyWeb(vm, {
    userId,
    message: options.message,
    buttonLabel: options.buttonLabel,
  });

  return true;
}

export default {
  LEGACY_WEB_SSO_ACTION,
  getLegacyWebBaseUrl,
  fetchLegacyWebSsoUrl,
  openLegacyWebDashboard,
  promptGeneralManagerLegacyWeb,
  handleBlockedRoleForVueSwitch,
};
